var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-table-heading d-flex align-center mb-2"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":"Logo","width":"28","height":"28"}}):_vm._e(),(_vm.title)?_c('SrHeadline',{staticClass:"mb-0 ml-3",attrs:{"level":"2"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }